export const seatStatuses = {
  6664: true,
  6665: true,
  6666: true,
  6667: true,
  6668: false,
  6669: false,
  6670: true,
  6671: true,
  6672: true,
  6673: true,
  6681: true,
  6682: true,
  6683: true,
  6684: true,
  6685: true,
  6686: true,
  6687: true,
  6688: true,
  6689: true,
  6690: true,
  6743: true,
  6744: true,
  6745: true,
  6746: true,
  6747: false,
  6748: false,
  6749: false,
  6750: true,
  6751: true,
  6752: true,
  6753: true,
  6761: true,
  6762: true,
  6763: true,
  6764: true,
  6765: true,
  6766: true,
  6767: true,
  6768: false,
  6769: false,
  6770: false,
  6771: false,
  6823: false,
  6824: true,
  6825: true,
  6826: true,
  6827: true,
  6828: true,
  6829: true,
  6830: true,
  6831: true,
  6832: true,
  6833: true,
  6841: true,
  6842: true,
  6843: true,
  6844: true,
  6845: true,
  6846: true,
  6847: true,
  6848: true,
  6849: true,
  6850: true,
  6851: true,
  6903: true,
  6904: true,
  6905: true,
  6906: true,
  6907: true,
  6908: true,
  6909: true,
  6910: false,
  6911: false,
  6912: false,
  6913: true,
  6921: true,
  6922: true,
  6923: true,
  6924: true,
  6925: true,
  6926: true,
  6927: true,
  6928: true,
  6929: true,
  6930: true,
  6931: true,
  6981: true,
  6982: true,
  6983: true,
  6984: true,
  6985: true,
  6986: true,
  6987: true,
  6988: true,
  6989: true,
  6990: true,
  6991: true,
  6992: true,
  6993: true,
  7001: true,
  7002: true,
  7003: true,
  7004: true,
  7005: true,
  7006: true,
  7007: true,
  7008: true,
  7009: true,
  7010: true,
  7011: true,
  7012: true,
  7013: true,
  7061: false,
  7062: true,
  7063: false,
  7064: true,
  7065: true,
  7066: true,
  7067: true,
  7068: true,
  7069: true,
  7070: true,
  7071: true,
  7072: true,
  7073: true,
  7081: true,
  7082: true,
  7083: true,
  7084: true,
  7085: true,
  7086: true,
  7087: true,
  7088: true,
  7089: true,
  7090: true,
  7091: true,
  7092: true,
  7093: true,
  7141: true,
  7142: true,
  7143: true,
  7144: true,
  7145: true,
  7146: true,
  7147: true,
  7148: true,
  7149: true,
  7150: true,
  7151: true,
  7152: true,
  7153: true,
  7161: true,
  7162: true,
  7163: true,
  7164: true,
  7165: true,
  7166: true,
  7167: true,
  7168: true,
  7169: true,
  7170: true,
  7171: true,
  7172: true,
  7173: true
};
